import { Grid, MenuItem, FormControl, CircularProgress, Backdrop, Link, Box, InputLabel } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import configurations from "config";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { useMaterialUIController, setReturnRequestContext } from "context";
import { RETURN_REQUEST } from "constants.js";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import VisibilityIcon from '@mui/icons-material/Visibility';

function List() {
    const navigate = useNavigate();
    const { pageNo } = useParams();
    var pageSelected = 1;
    const [controller, dispatch, initialState] = useMaterialUIController();
    const { returnRequestContext, MyContext } = controller;
    if (typeof pageNo !== "undefined") {
        const parts = pageNo.split("-");
        pageSelected = parts[1].trim();
    }
    const { t } = useTranslation();
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
    const [returnRequestData, setData] = useState({});
    const [responseResultCount, setResponseResultCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            minWidth: "500px",
            maxHeight: 300,
            overflowY: 'auto',
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const [isReturnRequestContextChanged, setReturnRequestContextChanged] = useState(false);

    const data = async () => {
        setIsLoading(true);
        toast.dismiss();

        await axios.get(baseUrl + "/return/list?pageSelected=" + pageSelected + "&statusFilter=" + returnRequestContext.statusFilter + "&orderBy=" + returnRequestContext.orderBy + "&orderValue=" + returnRequestContext.orderValue + "&searchBy=" + returnRequestContext.searchBy + "&searchValue=" + returnRequestContext.searchValue, {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
        }).then(function (response) {
            setIsLoading(false);
            const message = response.data.message;
            response.status == 200 ?
                (
                    response.data.status == 1 ?
                        (setData(response.data),
                            (response.data && response.data.data && response.data.data.totalCount) ?
                                setResponseResultCount(response.data.data.totalCount)
                                :
                                null)
                        :
                        toast.error(t(message))
                )
                :
                toast.error(t('unableToProccessRequest'));
        }).catch(function (error) {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    }

    useEffect(() => {
        data();
    }, [pageNo]);

    const handleResetFilters = () => {
        setReturnRequestContext(dispatch, initialState.returnRequestContext);
        setReturnRequestContextChanged(false);
        if (typeof pageNo === "undefined")
            navigate("/returnRequests/list/page-1");
        else
            navigate("/returnRequests/list");
    };

    useEffect(() => {
        const hasChanged = Object.keys(returnRequestContext).some(
            key => returnRequestContext[key] !== initialState.returnRequestContext[key]
        );
        setReturnRequestContextChanged(hasChanged);
    }, [returnRequestContext]);

    const columns = [
        { Header: t("Id"), accessor: "id", align: "left" },
        { Header: t("orderId"), accessor: "orderId", align: "left" },
        { Header: t("productTitle"), accessor: "productTitle", align: "left" },
        { Header: t("quantity"), accessor: "quantity", align: "left" },
        { Header: t("returnReason"), accessor: "returnReason", align: "left" },
        { Header: t("Status"), accessor: "status", align: "left" },
        { Header: t("action"), accessor: "action", align: "center" }
    ];

    const finalObj = [];
    if (returnRequestData.data && returnRequestData.data.rows) {
        let returnRequests = returnRequestData.data.rows;
        for (const rowKey in returnRequestData.data.rows) {
            let returnRequestRecord = returnRequests[rowKey];
            if (returnRequestRecord.id > 0) {
                let tempObj = {
                    id: '#' + returnRequestRecord.id,
                    orderId: '#' + returnRequestRecord.orderId,
                    productTitle: returnRequestRecord.productTitle,
                    quantity: returnRequestRecord.quantity,
                    returnReason: <HtmlTooltip
                        title={
                            <>
                                {returnRequestRecord.customerNote}
                            </>
                        }>
                        <span>
                            {returnRequestRecord.returnReason}
                            {(returnRequestRecord.customerNote) ? <ReadMoreIcon className="readMoreIcon" /> : null}
                        </span>
                    </HtmlTooltip>,
                    status: <span className={'statusD' + returnRequestRecord.status}>
                        {(returnRequestRecord.status == RETURN_REQUEST.REQUESTED) ? <span>{t('requested')}</span> :
                            (returnRequestRecord.status == RETURN_REQUEST.OPEN) ? <span>{t('open')}</span> :
                                (returnRequestRecord.status == RETURN_REQUEST.DECLINED) ? <span>{t('declined')}</span> :
                                    (returnRequestRecord.status == RETURN_REQUEST.CLOSED) ? <span>{t('closed')}</span> : null}</span>,
                    action:
                        <span className="actionClass">
                            <Link onClick={(event) => { event.preventDefault(); navigate("/returnRequests/details/" + returnRequestRecord.id) }}>
                                <Box className="squareBoxView">
                                    <VisibilityIcon color="success" fontSize="medium" titleAccess={t("View")} />
                                </Box>
                            </Link>
                        </span>
                };
                finalObj.push(tempObj);
            }
        }
    }
    const rows = finalObj;

    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={t("returnRequest")} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {(Object.keys(returnRequestData).length > 0) ?
                <MDBox pt={6} pb={3} className="ContentSectionBox">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                                <Grid container className="FilterSectionBox FilterSectionBox" spacing={2}>
                                    <Grid item xs={12} sm={2} md={2} className="filterGrid" >
                                        <MDInput
                                            select
                                            name="statusFilter"
                                            label={t('status')}
                                            value={returnRequestContext.statusFilter}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, statusFilter: obj.target.value });
                                            }} fullWidth
                                        >
                                            <MenuItem value='all'>{t('all')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.REQUESTED}>{t('requested')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.OPEN}>{t('open')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.DECLINED}>{t('declined')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.CLOSED}>{t('closed')}</MenuItem>
                                        </MDInput>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                                        <MDInput
                                            select
                                            name="searchBy"
                                            label={t('searchBy')}
                                            value={returnRequestContext.searchBy}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            onChange={(obj) => {
                                                if (obj.target.value == 'none') {
                                                    setReturnRequestContext(dispatch, { ...returnRequestContext, searchValue: '', searchBy: obj.target.value });
                                                }
                                                else
                                                    setReturnRequestContext(dispatch, { ...returnRequestContext, searchBy: obj.target.value });
                                            }} fullWidth
                                        >
                                            <MenuItem value={'none'}>{t('none')}</MenuItem>
                                            <MenuItem value={"orderId"}>{t('orderId')}</MenuItem>
                                        </MDInput>
                                    </Grid>

                                    {(returnRequestContext.searchBy != "none") ?
                                        <Grid item xs={12} sm={2} md={2} className="filterGrid">
                                            <FormControl >
                                                <InputLabel className='SearchInputHead'>{t('Search Input')}</InputLabel>
                                                <MDInput
                                                    key={'searchValue'}
                                                    value={returnRequestContext.searchValue}
                                                    type="text"
                                                    name="searchValue"
                                                    InputProps={{
                                                        classes: { root: "filterStyle" },
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(obj) => {
                                                        setReturnRequestContext(dispatch, { ...returnRequestContext, searchValue: obj.target.value });
                                                    }} fullWidth />
                                            </FormControl>
                                        </Grid>
                                    : <></>}


                                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                                        <MDInput
                                            select
                                            name="orderBy"
                                            value={returnRequestContext.orderBy}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            label={t('orderBy')}
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, orderBy: obj.target.value });
                                            }} fullWidth
                                        >
                                            <MenuItem value={'id'}>{t('id')}</MenuItem>
                                        </MDInput>
                                    </Grid>

                                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                                        <MDInput
                                            select
                                            name="orderValue"
                                            value={returnRequestContext.orderValue}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            label={t('order')}
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, orderValue: obj.target.value });
                                            }}
                                            fullWidth
                                        >
                                            <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                                            <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                                        </MDInput>
                                    </Grid>

                                    <Grid item md={2} sm={3} xs={6} className="displyFlex FilterSectionInnerBox filterGrid">
                                        <FormControl className='formcontrolFilterStyleNoYMargin'>
                                            <MDButton onClick={() => { pageSelected = 1; data(); }} key="submit" type="submit" color="info" size="small" disableRipple fullWidth>{t('submit')}</MDButton>
                                        </FormControl>



                                        {isReturnRequestContextChanged && (
                                            <FormControl className='formcontrolFilterStyleNoYMargin'>
                                                <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                                            </FormControl>)}


                                    </Grid>
                                </Grid>
                            </MDBox>
                            <MDBox pt={3}>
                                <DataTable
                                    table={{ columns, rows }}
                                    isSorted={false}
                                    showTotalEntries={true}
                                    responseResultCount={responseResultCount}
                                    paginationSize={MyContext.paginationSize}
                                    paginationLink={"/returnRequests/list/page-"}
                                    pageSelected={pageSelected}
                                />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                :
                <MDBox pt={6} pb={3}><span className="noResult">{t('noRecordsFound')}</span></MDBox>
            }
        </DashboardLayout>
    );
}

export default List;
